import { Slot } from '@radix-ui/react-slot'
import {
  createContext,
  createRef,
  type VFC,
  ReactChild,
  type RefObject,
  useContext,
  useRef,
} from 'react'

const ModalDialogContext = createContext<RefObject<HTMLElement>>(createRef())

/**
 * Provides a ref object for the portal container of the closest ancestor
 * dialog, if any are open.
 */
export const useModalDialogContext = () => useContext(ModalDialogContext)

/**
 * This provider should wrap the <Dialog.Content> component of portalled Radix
 * dialogs, so their children can be aware of the portal context.
 */
export const ModalDialogContextProvider: VFC<{ children: ReactChild }> = (
  props
) => {
  const ref = useRef<HTMLElement>(null)

  return (
    <ModalDialogContext.Provider value={ref}>
      <Slot {...props} ref={ref} />
    </ModalDialogContext.Provider>
  )
}
ModalDialogContextProvider.displayName = 'Lapidary: ModalDialogContextProvider'
